import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import baseTheme from "./base";

export const createTheme = (theme) => {
  const baseThemeCp = cloneDeep(baseTheme);
  return merge(baseThemeCp, theme);
};
